import React, { createContext, useContext, useMemo, useState } from 'react';

const RuntimeSettingsContext = createContext(null);

const DEFAULT_MODEL_NAME = 'gpt-5.4';
const DEFAULT_RESIZE_MODE = 'original';
const DEFAULT_COMPRESSION_MODE = 'none';
const DEFAULT_USE_EBAY_RAG = false;
const DEFAULT_USE_NOTES_RAG = false;
const DEFAULT_ASSUME_HIDDEN_ITEMS = true;

export const RuntimeSettingsProvider = ({ children }) => {
  const [modelName, setModelName] = useState(DEFAULT_MODEL_NAME);
  const [resizeMode, setResizeMode] = useState(DEFAULT_RESIZE_MODE);
  const [compressionMode, setCompressionMode] = useState(DEFAULT_COMPRESSION_MODE);
  const [useEbayRag, setUseEbayRag] = useState(DEFAULT_USE_EBAY_RAG);
  const [useNotesRag, setUseNotesRag] = useState(DEFAULT_USE_NOTES_RAG);
  const [assumeHiddenItems, setAssumeHiddenItems] = useState(DEFAULT_ASSUME_HIDDEN_ITEMS);

  const value = useMemo(() => ({
    modelName,
    setModelName,
    resizeMode,
    setResizeMode,
    compressionMode,
    setCompressionMode,
    useEbayRag,
    setUseEbayRag,
    useNotesRag,
    setUseNotesRag,
    assumeHiddenItems,
    setAssumeHiddenItems,
  }), [
    modelName,
    resizeMode,
    compressionMode,
    useEbayRag,
    useNotesRag,
    assumeHiddenItems,
  ]);

  return (
    <RuntimeSettingsContext.Provider value={value}>
      {children}
    </RuntimeSettingsContext.Provider>
  );
};

export const useRuntimeSettings = () => {
  const context = useContext(RuntimeSettingsContext);
  if (!context) {
    throw new Error('useRuntimeSettings must be used within RuntimeSettingsProvider.');
  }
  return context;
};
